import Cookies from 'js-cookie';

const LoginKey = 'hasLogin';

export function getToken() {
  return Cookies.get(LoginKey);
}

export function setToken() {
  return Cookies.set(LoginKey, true);
}

export function removeToken() {
  return Cookies.remove(LoginKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js